import{tag as t}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const Dash100Icon=()=>t`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    aria-hidden="true"
    fill="currentColor"
  >
    <path d="M8.5 6h-7a1 1 0 010-2h7a1 1 0 010 2z" />
  </svg>`;
//# sourceMappingURL=Dash100.js.map
